module.exports = __webpack_public_path__ + "img/pdf_logo.e45b7852.png";